export const defaultStyles = {
  color: "blue3.main",
  "& .MuiStepLabel-root .Mui-completed": {
    color: "green4.main",
  },
  "& .MuiStepLabel-root .Mui-active": {
    color: "blue3.main",
  },
};
